import React, { useState } from 'react';

const SUPPORTED_MACROS = [
    { label: 'User ID', value: '[USER_ID]', description: 'Unique ID of the viewer' },
    { label: 'Video ID', value: '[VIDEO_ID]', description: 'ID of the content being watched' },
    { label: 'Tenant ID', value: '[TENANT_ID]', description: 'Tenant ID' },
    { label: 'Timestamp', value: '[TIMESTAMP]', description: 'Unix timestamp (seconds)' },
    { label: 'Cachebuster', value: '[CACHEBUSTER]', description: 'Random string to prevent caching' },
    { label: 'Device Type', value: '[DEVICE_TYPE]', description: 'web, mobile, or tv' },
    { label: 'IP Address', value: '[IP]', description: 'Client IP address' },
    { label: 'User Agent', value: '[UA]', description: 'Client User-Agent (encoded)' },
];

const MacroHelper = ({ onSelectMacro, currentUrl = "" }) => {
    const [paramName, setParamName] = useState("");
    const [selectedMacro, setSelectedMacro] = useState(SUPPORTED_MACROS[0].value);

    const handleAddMapping = () => {
        if (!paramName.trim()) return;
        
        let newUrl = currentUrl;
        const separator = newUrl.includes('?') ? '&' : '?';
        newUrl += `${separator}${paramName.trim()}=${selectedMacro}`;
        
        onSelectMacro(newUrl);
        setParamName("");
    };

    const handleInsertDirect = (macro) => {
        // This logic is simple: append to the end if not handled by parent ref
        // In the parent, we might want more sophisticated caret insertion
        onSelectMacro(currentUrl + macro);
    };

    return (
        <div className="macro-helper-container mt-3 p-3 border rounded bg-light">
            <h6 className="mb-2"><i className="fa fa-magic mr-2"></i>SSAI Macro Helper</h6>
            <p className="small text-muted mb-3">Insert macros directly or use the mapping tool to append parameters.</p>
            
            <div className="direct-macros mb-3">
                <label className="small font-weight-bold d-block mb-1">Quick Insert:</label>
                <div className="d-flex flex-wrap gap-2">
                    {SUPPORTED_MACROS.map(m => (
                        <button 
                            key={m.value}
                            type="button"
                            className="btn btn-sm btn-outline-primary mb-1 mr-1" 
                            onClick={() => handleInsertDirect(m.value)}
                            title={m.description}
                        >
                            {m.value}
                        </button>
                    ))}
                </div>
            </div>

            <div className="macro-mapping-tool mt-3">
                <label className="small font-weight-bold d-block mb-1">Mapping Tool:</label>
                <div className="input-group input-group-sm">
                    <input 
                        type="text" 
                        className="form-control" 
                        placeholder="Param name (e.g. user_id)" 
                        value={paramName}
                        onChange={(e) => setParamName(e.target.value)}
                    />
                    <select 
                        className="form-select border-left-0"
                        style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                        value={selectedMacro}
                        onChange={(e) => setSelectedMacro(e.target.value)}
                    >
                        {SUPPORTED_MACROS.map(m => (
                            <option key={m.value} value={m.value}>{m.label} ({m.value})</option>
                        ))}
                    </select>
                    <button 
                        className="btn btn-primary" 
                        type="button"
                        onClick={handleAddMapping}
                    >
                        Add to URL
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MacroHelper;
